export const CFG = {
  api: location.protocol === 'https:'
    ? 'https://cal.spas-sky.ru'
    : `http://${location.hostname}:8889`,
  strava: location.protocol === 'https:'
    ? `${location.origin}/strava`
    : `http://${location.hostname}:8891`,
  tdee: 2337,
  targetCal: 1850,
  calRange: [1600, 2100] as const,
  protein: 176,
  fat: 69,
  carbs: 130,
  weight: 98,
};

export const DAY_NAMES = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
export const MONTH_NAMES = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
export const SPORT_NAMES: Record<string, string> = {
  Run: 'бег', Ride: 'вело', Swim: 'плав.', Walk: 'ходьба',
  Hike: 'хайк', WeightTraining: 'силовая', Yoga: 'йога', Workout: 'трен.',
};
